module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/5/1-c5e1d22b7670eadab5ee0abdb3c28666.jpg";